"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITEM_TPL = exports.CONTAINER_TPL = exports.VALUE_CLASS = exports.MARKER_CLASS = exports.LIST_ITEM_CLASS = exports.LIST_CLASS = exports.TITLE_CLASS = exports.CONTAINER_CLASS = void 0;
exports.CONTAINER_CLASS = 'l7plot-legend l7plot-legend__category';
exports.TITLE_CLASS = 'l7plot-legend__title';
exports.LIST_CLASS = 'l7plot-legend__category-list';
exports.LIST_ITEM_CLASS = 'l7plot-legend__list-item';
exports.MARKER_CLASS = 'l7plot-legend__category-marker';
exports.VALUE_CLASS = 'l7plot-legend__category-value';
exports.CONTAINER_TPL = `<div class="${exports.CONTAINER_CLASS}">
  <div class="${exports.TITLE_CLASS}"></div>
  <ul class="${exports.LIST_CLASS}"></ul>
</div>`;
exports.ITEM_TPL = `<li class="${exports.LIST_ITEM_CLASS}" data-index={index}>
  <span class="${exports.MARKER_CLASS}" style="background:{color}"></span>
  <span class="${exports.VALUE_CLASS}">{value}</span>
</li>`;
//# sourceMappingURL=constants.js.map